export default "__VITE_ASSET__CwQO3Zkv__"